<template>
  <div class="calendar-header-container">
    <div class="left-wrap">
      <el-button @click="handleGoToday" class="header-btn" style="margin-right:21px;">Today</el-button>
      <month-select :currentDate="currentDate" @previousDate="handlePreviousDate" @nextDate="handleNextDate"></month-select>
    </div>
    <div class="right-wrap">
      <el-checkbox-group @change="handleChangeEventType" class="checkbox-group" v-model="checkList">
        <el-checkbox class="checkbox-item checkbox-legend-blue" label="Promotion Event"></el-checkbox>
        <el-checkbox class="checkbox-item checkbox-legend-green" label="Confirmed Event"></el-checkbox>
      </el-checkbox-group>
      <el-button class="header-btn" style="margin-right:10px;" @click="handleOpenFilter">Filter</el-button>
      <el-button class="header-btn" @click="handleExport">Export</el-button>
    </div>
  </div>
</template>

<script>
import monthSelect from './month-select'
export default {
  name: "calendar-header",
  components: {
    monthSelect
  },
  props:{
    currentDate:{
      type:Object,
      default:()=>{
        return this.$dayjs()
      }
    },
    sourceType:{
      type:Array,
      default:()=>{
        return ['Confirmed Event']
      }
    }
  },
  watch:{
    sourceType: {
      handler: function(e) {
        this.checkList = e
      },
      deep: true
    }
  },
  data() {
    return {
      checkList:['Confirmed Event']
    };
  },
  computed: {},
  methods:{
    handlePreviousDate(){
      this.$emit('previousDate')
    },
    handleNextDate(){
      this.$emit('nextDate')
    },
    handleGoToday(){
      this.$emit('goToday')
    },
    handleOpenFilter(){
      this.$emit('openFilter')
    },
    handleChangeEventType(){
      console.log("1111",this.checkList)
      this.$emit('changeEventType',this.checkList)
    },
    handleExport(){
      const params={
        begDate:this.currentDate.startOf('year').format('YYYY-MM-DD'),
        endDate:this.currentDate.endOf('year').format('YYYY-MM-DD')
      }
      this.$emit("export",params)
    }
  }
};
</script>

<style lang="scss" scoped>
  ::v-deep .el-checkbox__input{
    transform: scale(1.5);
  }
  .header-btn{
    font-weight: 600;
    color:rgb(103,106,108);
    font-size:14px;
    height:40px;
    min-width:86px;
  }
  .calendar-header-container{
    width:100%;
    // background: blue; 
    padding:20px 0;
    display:flex;
    justify-content: space-between;
    align-items: center;
    .left-wrap{
      display: flex;
    }
    .right-wrap{
      display: flex;
      .checkbox-group{
        display: flex;
        align-items: center;
        .checkbox-item{
          padding-right:40px;
          font-size:14px;
          color:rgb(48,49,51);
          position: relative;
        }
        .checkbox-legend-blue:after{
          content:'Legend';
          width:70px;
          height:20px;
          position: absolute;
          bottom:-25px;
          left:50%;
          background: rgb(205, 229, 255);
          border:1px solid rgb(64, 158, 255);
          transform: translateX(-70%);
          border-radius:4px;
          font-size: 10px;
          text-align: center;
        }
        .checkbox-legend-green:after{
          content:'Legend';
          width:70px;
          height:20px;
          position: absolute;
          bottom:-25px;
          left:50%;
          background: rgb(233, 244, 241);
          border:1px solid rgb(26, 179, 148);
          transform: translateX(-70%);
          border-radius:4px;
          font-size: 10px;
          text-align: center;
        }
      }
    }
  }
</style>
